// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3E4Du","content":"styles_content__1_DZ9","tableWrap":"styles_tableWrap__34zdi"};